export const DESKTOP_BREAKPOINT = 1024;
export const TABLET_BREAKPOINT = 768;
